// extracted by mini-css-extract-plugin
module.exports = {"noPermission":"_95107347","privateFolder":"_2852b156","access":"_b9d416e9"};